export default {
  data: () => ({
    form: {}
  }),

  computed: {
    firstCharsCompanyName() {
      return this.form.name ? this.form.name.substring(0, 2) : '';
    }
  }
};
